import React, { useEffect, useState } from 'react';
import classes from './Notification.module.scss';
import { Flex, Typography } from 'antd';
import moment from 'moment/moment';
import { GreyContainer } from 'common/components/UI';
import { CloseCircleFilled, CloseCircleOutlined } from '@ant-design/icons';

type NotificationProps = {
  title: string,
  text: string,
  date: string,
  unread?: boolean
  onClick: () => void
  deleteNotify: (id: number) => void
  id: number
}

const { Text } = Typography;

const UnreadIcon = <div className={classes.unreadIcon}></div>;

const Notification: React.FC<NotificationProps> = ({ title, text, date, unread,onClick, id, deleteNotify }) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    countLines();
  }, []);

  const handleClick = () => {
    setOpen(!open);
    onClick()
  };

  const countLines = () => {
    const text = document.getElementById('notification-text') as HTMLElement;
    const divHeight = text.offsetHeight;
    const lineHeight = 22;
    const lines = divHeight / lineHeight;

    const notification = document.getElementById('notification') as HTMLElement;
    if (lines >= 4)
      notification.style.cursor = 'pointer';
  };



  return (
    <GreyContainer
      id="notification"
      className={classes.notification}
      title={title}
      onClick={handleClick}
      action={unread ? UnreadIcon : undefined}
    >
   
      <Flex vertical gap={16}>
        <CloseCircleFilled className={classes.delete} onClick={(e) => {
          e.stopPropagation();
          deleteNotify(id);
        }}/>
        <Text
          id="notification-text"
          className={`${classes.notification__text} ${open ? classes.notification__text_open : ''}`}
        >
          {text}
        </Text>
        <Text style={{ opacity: 0.6 }}>{moment(date, 'DD-MM-YYYY hh:mm:ss').format('DD MMMM YYYY, hh:mm a')}</Text>
      </Flex>
    </GreyContainer>
  );
};

export default Notification;